import { formatChatTimestamp, formatFullDateTime } from '@saaga/shared/utils/format.util'
import { memo } from 'react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export interface ChatTimestampProps {
  timestamp: string | Date

  className?: string
}

const ChatTimestampBase: React.FC<ChatTimestampProps> = ({ timestamp, className }) => {
  const relativeTime = formatChatTimestamp(timestamp)
  const fullDateTime = formatFullDateTime(timestamp)

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('cursor-default text-xs text-muted-foreground', className)}>
          {relativeTime}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" sideOffset={4}>
        {fullDateTime}
      </TooltipContent>
    </Tooltip>
  )
}

export const ChatTimestamp = memo(ChatTimestampBase)

ChatTimestamp.displayName = 'ChatTimestamp'
